/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_DescriptionInputs */



/**
* | output |
* | --- |
* | "A partner's bills as its ERP file — exactly the file the partner downloads — or the usage behind them." |
*
* @param {Admin_Export_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_description = /** @type {((inputs?: Admin_Export_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Rechnungen eines Partners als seine ERP-Datei — genau die Datei, die der Partner herunterlädt — oder die Nutzung dahinter.")
	return /** @type {LocalizedString} */ ("A partner's bills as its ERP file — exactly the file the partner downloads — or the usage behind them.")
});